/// <reference path="Assistant.ts" />

namespace TerminalApp {


    export class PlacementFinderAssistant extends Assistant {
        select_type_menu = document.createElement("div");
        scan_placement_menu = document.createElement("div");
        result_menu = document.createElement("div");

        placement_container: HTMLElement;

        refill: boolean;
        empty: boolean;

       

        callback: (placementId: number, placementData: string) => any;
        constructor() {
            super();
            this.scan_placement_menu.innerHTML = `
                <h1>${SP.Localize("sentance_scan_placement")}</h1>
                <center><img id="pfa_scan_placement" src="/terminal/img/scan.png"></center>

                 <h1>${SP.Localize("sentance_scan_product")}</h1>
                <center><img id="pfa_scan_product" src="/terminal/img/scan.png"></center>
                `;

            var placement_btn = this.scan_placement_menu.querySelector("#pfa_scan_placement") as HTMLElement;
            placement_btn.style.pointerEvents = "all";
            placement_btn.addEventListener("click", () => {
                placementPickerAssistant.open(null, null, placementInfo => {
                    this.open_result(placementInfo.id, null);
                });
            });

            var product_btn = this.scan_placement_menu.querySelector("#pfa_scan_product") as HTMLElement;
            product_btn.style.pointerEvents = "all";
            product_btn.addEventListener("click", () => {
                itemSearchAssistant.open(null, null, false, itemInfo => {
                    this.open_result(null, itemInfo.id);
                });
            });



            this.result_menu.innerHTML = `
            <div class='existing_placements'></div>
            `;

            this.placement_container = this.result_menu.querySelector(".existing_placements");

            this.select_type_menu.innerHTML = `
                <h1>${SP.Localize('sentance_find_stock_placement')}</h1>

                <div id="pfa_find_pick" class="btn noselect"><div class="icon fa" style="color:black"><i class="fa-duotone fa-shelves"></i></div><div class="action">${SP.Localize('sentance_pick_placement')}</div>${SP.Localize('sentance_all_placements')}</div>

                <div id="pfa_find_pick_empty" class="btn noselect"><div class="icon fa" style="color:black"><i class="fa-duotone fa-shelves-empty"></i></div><div class="action">${SP.Localize('sentance_pick_placement')}</div>${SP.Localize('sentance_only_empty_placements')}</div>

                <div id="pfa_find_refill" class="btn noselect"><div class="icon fa" style="color:black"><i class="fa-solid fa-shelves"></i></div><div class="action">${SP.Localize('sentance_refill_placement')}</div>${SP.Localize('sentance_all_placements')}</div>

                <div id="pfa_find_refill_empty" class="btn noselect"><div class="icon fa" style="color:black"><i class="fa-solid fa-shelves-empty"></i></div><div class="action">${SP.Localize('sentance_refill_placement')}</div>${SP.Localize('sentance_only_empty_placements')}</div>
                `;

            var find_pick = this.select_type_menu.querySelector("#pfa_find_pick") as HTMLElement;
            var find_pick_empty = this.select_type_menu.querySelector("#pfa_find_pick_empty") as HTMLElement;
            var find_refill = this.select_type_menu.querySelector("#pfa_find_refill") as HTMLElement;
            var find_refill_empty = this.select_type_menu.querySelector("#pfa_find_refill_empty") as HTMLElement;



            find_pick.addEventListener("click", () => {
                this.refill = false;
                this.empty = false;
                this.open_placement_scan();
            });

            find_pick_empty.addEventListener("click", () => {
                this.refill = false;
                this.empty = true;
                this.open_placement_scan();
            });

            find_refill.addEventListener("click", () => {
                this.refill = true;
                this.empty = false;
                this.open_placement_scan();
            });

            find_refill_empty.addEventListener("click", () => {
                this.refill = true;
                this.empty = true;
                this.open_placement_scan();
            });

            /* <div class="btn noselect"><div class="icon fa" style="color:black"><i class="fa-solid fa-calculator"></i></div><div class="action">${SP.Localize('sentance_find_pick_placement')}</div>Fjern eller opdater lagermængden</div>*/


            this.container.appendChild(this.select_type_menu);
            this.container.appendChild(this.scan_placement_menu);
            this.container.appendChild(this.result_menu);

        }


        hide() {
            this.container.style.display = "none";
            this.scan_placement_menu.style.display = "none";
            this.select_type_menu.style.display = "none";
            this.result_menu.style.display = "none";
        }


        open_select_type() {
            this.hide();
            this.container.style.display = "block";
            this.select_type_menu.style.display = "block";
        }

        open_placement_scan() {
            this.hide();
            this.container.style.display = "block";
            this.scan_placement_menu.style.display = "block";
        }

        async open_result(placementId: number, itemId: string) {
            this.hide();
            this.container.style.display = "block";
            this.result_menu.style.display = "block";

            this.placement_container.innerHTML = `<center><video playsinline autoplay muted loop=""><source src="/terminal/img/loading.webm" type="video/webm"></video></center>`;


            var url = `/api/v1/info/freePlacementDatas?refill=${this.refill}&empty=${this.empty}`;

            if (placementId)  url += `&NearPlacementId=${placementId}`;
            if (itemId) url += `&NearItemId=${itemId}`;
            

            var data: any = await SP.get(url);

            console.log("DATE:", data);

            this.placement_container.innerHTML = "";
            var placements = data.data.placements as any[];
            var lots = data.data.lots as any[];

            var showCount = 10;

            //insert exsising  header
            if (lots.length) this.placement_container.innerHTML = `<h1>${SP.Localize("sentance_existing_placements")}</h1>`;

            lots.forEach((d, index) => {
                if (index > showCount) return;
                var distance = d.distance as number;
                var lot = d.lotInfo as SP.StockingLotInfo;

                var pi = new PlacementInfoBox(lot.stockPlacementData, true, lot.item, lot.placementQuantityItemAllLots, distance);
                var container = document.createElement("div");
                container.classList.add("audit_zone_placement");
                container.appendChild(pi.container);
                this.placement_container.appendChild(container);

                container.addEventListener("click", () => {
                    if (this.callback) {
                        this.callback(lot.stockPlacementId, lot.stockPlacementData);
                        this.close();
                    }
                });
            });

            //insert lots header
            if (placements.length) this.placement_container.innerHTML += `<h1>${SP.Localize("word_placements")}</h1>`;

            placements.forEach((d, index) => {
                if (index > showCount) return;
                var distance = d.distance as number;
                var data = d.placementData as string;

                var pi = new PlacementInfoBox(data, true, null, null, distance);
                var container = document.createElement("div");
                container.classList.add("audit_zone_placement");
                container.appendChild(pi.container);
                this.placement_container.appendChild(container);

                container.addEventListener("click", () => {
                    if (this.callback) {
                        this.callback(pi.id, data);
                        this.close();
                    }
                });
            });
        }

        bound = false;

        async open(callback: (placementId: number, placementData: string) => any) {
            this.callback = callback;
            this.open_select_type();


            if (!this.bound) {
                barcodeListener.on("sp", this.scanPlacement, this);
                barcodeListener.on(null, this.scanBarcode, this);
                this.bound = true;
            }
        }

        close() {
            if (this.bound) {
                barcodeListener.off("sp", this.scanPlacement);
                barcodeListener.off(null, this.scanBarcode);
                this.bound = false;
            }
            super.close();
        }

        scanPlacement(id: string) {
            SP.blurActive();
            this.open_result(parseInt(id), null);
            return false; //prevent default
        }

        scanBarcode(barcode: string) {
            SP.blurActive();
            itemSearchAssistant.open(null, barcode, false, itemInfo => {
                this.open_result(null, itemInfo.id);
            });
            return false; //prevent default
        }
    }


}